<template>
  <div>
    <div class="component-container">
      <div class="container-head contain-btn-title">
        <div class="container-head-title">
          <el-form label-width="80px">
            <div class="member-form-wrapper">
              <el-form-item
                label="用户名:"
                size="small"
                style="font-weight: 500"
              >
                <el-input
                  v-model="form.name"
                  placeholder="请输入"
                  @keyup.enter.native="handleQueryClick"
                  :clearable="true"
                />
              </el-form-item>
              <el-form-item
                label="手机号:"
                size="small"
                style="font-weight: 500"
              >
                <el-input
                  v-model="form.phone"
                  placeholder="请输入"
                  @keyup.enter.native="handleQueryClick"
                  :clearable="true"
                />
              </el-form-item>
              <el-form-item
                label="所属机构:"
                size="small"
                style="font-weight: 500"
              >
                <yl-cascader
                  :props="{ checkStrictly: true }"
                  :options="departments"
                  v-model="form.departmentId"
                  @change="handleDeptChange"
                  :show-all-levels="false"
                  clearable
                  filterable
                >
                </yl-cascader>
              </el-form-item>
              <span class="member-head-opt-btn">
                <common-button
                  type="primary"
                  size="default"
                  image
                  @click="handleQueryClick"
                  >查询</common-button
                >
                <common-button
                  type="cancel"
                  size="default"
                  image
                  @click="resetConditions"
                  >重置</common-button
                >
              </span>
            </div>
          </el-form>
        </div>
      </div>
      <div class="container-body">
        <div class="member-manage-table">
          <el-table
            :header-cell-style="{
              background: '#E5F5F9',
              fontSize: '16px',
              color: '#353739'
            }"
            :stripe="true"
            row-class-name="vertical-align-top"
            size="small"
            v-loading="data.isLoading"
            :data="data.list"
            style="width: 100%;margin-top: 10px;"
            fit
          >
            <el-table-column
              sortable
              align="center"
              min-width="160"
              prop="name"
              label="用户名"
            ></el-table-column>
            <el-table-column
              sortable
              align="center"
              min-width="160"
              prop="userId"
              label="手机号"
            ></el-table-column>
            <el-table-column
              sortable
              align="center"
              min-width="120"
              prop="gender"
              label="性别"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.gender === '1'">男</span>
                <span v-else-if="scope.row.gender === '0'">女</span>
              </template>
            </el-table-column>
            <el-table-column
              sortable
              align="center"
              min-width="160"
              prop="section"
              label="科室"
            ></el-table-column>
            <el-table-column
              sortable
              align="center"
              min-width="160"
              prop="birthDate"
              label="出生日期"
            >
              <template slot-scope="scope">{{
                scope.row.birthDate | dateFormat
              }}</template>
            </el-table-column>
            <el-table-column
              sortable
              align="center"
              min-width="160"
              prop="educationCode"
              label="学历"
            ></el-table-column>
            <el-table-column
              sortable
              align="center"
              min-width="160"
              prop="hospitalDate"
              label="来院时间"
            >
              <template slot-scope="scope">{{
                scope.row.hospitalDate | dateFormat
              }}</template>
            </el-table-column>
            <el-table-column
              sortable
              align="center"
              min-width="150"
              prop="currentSectionPosition"
              label="当前科室职务"
            ></el-table-column>
            <el-table-column
              sortable
              align="center"
              min-width="150"
              prop="email"
              label="邮箱"
            ></el-table-column>
            <el-table-column
              sortable
              align="center"
              prop="majorDepartName"
              min-width="170"
              label="所属主机构"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.tp == '6'"
                  >{{ scope.row.pName }} - {{ scope.row.majorDepartName }}</span
                >
                <span v-else>{{ scope.row.majorDepartName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              sortable
              align="center"
              prop="lastModTime"
              label="最后更新时间"
              min-width="160"
            >
              <template slot-scope="scope">{{
                scope.row.lastModTime | datetimeFormat
              }}</template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="170"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  @click="handleViewClick(scope.row)"
                  style="border:0px !important;"
                  type="text"
                  size="small"
                  >查看</el-button
                >
                <el-button
                  @click="handleUpdateDeptClick(scope.row)"
                  style="border:0px !important;"
                  type="text"
                  size="small"
                  >修改机构</el-button
                >
                <el-button
                  @click.native="handleUpdateClick(scope.row)"
                  style="border:0px !important;"
                  type="text"
                  size="small"
                  >修改分数</el-button
                >

                <!--                <el-dropdown class="el-dropdown-link">-->
                <!--                  <el-button class="el-icon-more identity-link" type="info"-->
                <!--                             style="border: 0px;background-color: transparent"></el-button>-->
                <!--                  <el-dropdown-menu slot="dropdown">-->
                <!--                    <el-dropdown-item @click.native="handleViewClick(scope.row)">-->
                <!--                      <i class="el-icon-view"></i>-->
                <!--                      <el-button style="border:0px !important;" type="text" size="small">查看</el-button>-->
                <!--                    </el-dropdown-item>-->
                <!--                    <el-dropdown-item @click.native="handleUpdateDeptClick(scope.row)">-->
                <!--                      <i class="el-icon-edit"></i>-->
                <!--                      <el-button style="  border:0px !important;" type="text" size="small">修改机构</el-button>-->
                <!--                    </el-dropdown-item>-->
                <!--                    <el-dropdown-item @click.native="handleUpdateClick(scope.row)">   &lt;!&ndash;v-show="showTraditionalChinese && isAdmin"&ndash;&gt;-->
                <!--                      <i class="el-icon-edit"></i>-->
                <!--                      <el-button style="  border:0px !important;" type="text" size="small">修改分数</el-button>-->
                <!--                    </el-dropdown-item>-->
                <!--                  </el-dropdown-menu>-->
                <!--                </el-dropdown>-->
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
              style="float: right; padding: 3px 0"
              layout="sizes, prev, pager, next"
              :page-size="data.pageSize"
              :total="data.total"
              :page-sizes="data.pageSizeArray"
              @current-change="handlePageChange"
              @size-change="handleSizeChange"
              :current-page="data.currentPage"
            >
            </el-pagination>
          </div>
          <el-dialog
            :visible.sync="dialog.isShow"
            class="spec-dialog"
            @close="handleCloseDialog"
            width="500px"
          >
            <div class="dialog-title" slot="title">
              <template v-if="Object.is(dialog.dialogType, dialogType.update)"
                >编辑成员基本信息</template
              >
            </div>
            <el-form
              label-width="100px"
              v-loading="dialog.isLoading"
              :rules="rules"
              ref="ruleForm"
              :model="dialog.form"
            >
              <el-form-item label="姓名：" prop="name">
                <el-input
                  v-model="dialog.form.name"
                  type="text"
                  placeholder="请输入姓名"
                  v-bind:disabled="dialog.readOnlyFlg"
                  clearable
                >
                </el-input>
              </el-form-item>
              <el-form-item label="手机号：" prop="userId">
                <el-input
                  v-model="dialog.form.userId"
                  type="text"
                  placeholder="请输入手机号"
                  v-bind:disabled="dialog.readOnlyFlg"
                  clearable
                >
                </el-input>
              </el-form-item>
              <el-form-item label="所属机构" prop="majorDepartId">
                <yl-cascader
                  ref="editDeptCascader"
                  :props="{ checkStrictly: true }"
                  :options="departments"
                  @change="handleDialogDeptChange"
                  v-model="elementDeptId"
                  :show-all-levels="false"
                  filterable
                  style="width: 100%"
                >
                </yl-cascader>
              </el-form-item>
            </el-form>
            <template slot="footer">
              <el-button @click="handleCommitDialog" size="small" type="primary"
                >提交</el-button
              >
              <el-button @click="handleCloseDialog" size="small"
                >取消</el-button
              >
            </template>
          </el-dialog>

          <el-dialog
            class="view-dialog"
            :visible.sync="view.viewDialogFlag"
            @close="handleCloseDialog2"
          >
            <div style="height: 600px;overflow-y: auto">
              <userInfo
                v-if="view.viewDialogFlag"
                :userId="view.userId"
              ></userInfo>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
    <animation :loadingDataVisible="data.isLoading" />
  </div>
</template>
<script>
import defaultLang from "element-ui/lib/locale/lang/zh-CN";
import http from "@/utils/axios";
import { mapState } from "vuex";
import cookie from "@/utils/cookie";
import { Message } from "element-ui";
import animation from "@/components/loading/animation";
import {
  DIALOG_TYPE_ADD,
  DIALOG_TYPE_UPDATE,
  PAGE_SIZE_ARRAY
} from "@/constants/constants";
import * as constantsRules from "@/constants/constantRules";
import { getCascaderFullValue } from "@/utils/cascader";
import userInfo from "@/pages/user/userInfo";

export default {
  name: "MemberManage",
  components: {
    userInfo,
    animation
  },

  data() {
    return {
      elementDeptId: [],
      showTraditionalChinese: false,
      // deptPower: true,
      // superPower: true,
      departments: [], //部门数组
      form: {
        phone: "",
        name: "",
        departmentId: 0
      },
      query: {
        phone: "",
        name: "",
        departmentId: 0
      },
      data: {
        isLoading: false,
        list: [],
        pageNum: 1,
        pageSizeArray: PAGE_SIZE_ARRAY,
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      dialog: {
        dialogType: null,
        isShow: false,
        isLoading: false,
        readOnlyFlg: false,
        form: {
          name: "",
          userId: "",
          majorDepartId: ""
        }
      },
      dialogType: {
        add: DIALOG_TYPE_ADD,
        update: DIALOG_TYPE_UPDATE
      },
      loadingDataVisible: false,
      rules: constantsRules.BasicInfoRules,
      updateOrgFlg: false,

      view: {
        userId: "",
        viewDialogFlag: false
      },
      selectedDepartTp: null
    };
  },

  created() {
    this.$nextTick(args => {
      defaultLang.el.cascader.placeholder = "试试搜索：北京，或者选择";
    });
  },

  mounted() {
    this.getDepartments();
    this.queryData();
  },
  computed: {
    ...mapState({
      userPower: state => state.userPowerStore.userPower,
      superPower: state => state.userPowerStore.superPower,
      deptPower: state => state.userPowerStore.deptPower,
      deptListData: state => state.departmentStore.deptListData,
      treeDeptData: state => state.departmentStore.treeDeptData
    })

    // isAdmin(){
    //   if (this.deptPower || this.superPower){
    //     return true;
    //   }else {
    //     return false;
    //   }
    // }
  },

  watch: {
    userPower: {
      immediate: true,
      handler(newVal) {
        //控制是否显示省中医的资料信息
        this.showTraditionalChinese = this.$store.state.userPowerStore.IS_GPHOTCM;
      }
    }
  },
  methods: {
    //级联选择器选项发生变化
    handleDeptChange(value) {
      if (this.form.departmentId) {
        this.query.departmentId = this.form.departmentId[
          this.form.departmentId.length - 1
        ];
      }
    },

    //查询部门id
    getDepartments() {
      let token = cookie.getCookie("token");
      http
        .post(
          window.config.api.baseUrl + "/eims-api/department/findCurrentAndSub",
          {
            token: token,
            data: {
              pageSize: -1
            }
          }
        )
        .then(response => {
          this.departments = response.data.data.departments;
          //计算出医院的全id路径
          if (this.dialog.form.majorDepartId) {
            let departIds = getCascaderFullValue(
              this.departments,
              this.dialog.form.majorDepartId
            );
            this.elementDeptId = departIds;
          }
        });
    },

    handleQueryClick() {
      this.query.phone = this.form.phone;
      this.query.name = this.form.name;
      this.query.departmentId = this.form.departmentId[
        this.form.departmentId.length - 1
      ];
      this.handlePageChange(1);
    },
    resetConditions() {
      Object.assign(this.$data.form, this.$options.data().form);
      this.query.phone = this.form.phone;
      this.query.name = this.form.name;
      this.query.departmentId = this.form.departmentId;
      this.query.provinceCode = this.form.provinceCode;
      this.query.cityCode = this.form.cityCode;
      this.handlePageChange(1);
    },

    //查询列表
    queryData() {
      let _this = this;
      _this.data.isLoading = true;
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/member/list", {
          token: token,
          data: {
            userId: this.query.phone,
            name: this.query.name,
            departmentId: this.query.departmentId,
            pageNum: this.data.pageNum,
            pageSize: this.data.pageSize
          }
        })
        .then(response => {
          this.data.list = response.data.data.eimsUserList;
          this.data.total = response.data.data.total;
          _this.data.isLoading = false;
        });
    },

    //分页
    handlePageChange(val) {
      this.data.currentPage = val;
      this.data.pageNum = val;
      this.queryData();
    },
    handleSizeChange(val) {
      this.data.pageSize = val;
      this.queryData();
    },
    //查看 跳转到资料页面
    handleViewClick(row) {
      // this.isLoading = true;
      // this.$store.dispatch("setUserId",{"userId": row.userId});
      // this.$store.dispatch("setType",{"type": 'view'});
      // this.$router.push({path: '/uCenter/otherInfo',query:{flag:'1'}}).finally(() => {
      //   this.isLoading = false;
      // })

      let userId = row.userId;
      this.view.userId = userId;
      this.view.viewDialogFlag = true;
    },

    // //查看 跳转到资料页面
    // handleViewClick(row){
    //   this.isLoading = true;
    //   this.$store.dispatch("setUserId",{"userId": row.userId});
    //   this.$store.dispatch("setType",{"type": 'view'});
    //   this.$router.push({path: "/privateplot/member/basic",query:{flag:'1'}}).finally(() => {
    //     this.isLoading = false;
    //   })
    // },
    //查看 跳转到资料页面
    handleUpdateClick(row) {
      this.isLoading = true;
      this.$store.dispatch("setUserId", { userId: row.userId });
      this.$store.dispatch("setType", { type: "update" });
      this.$router
        .push({ path: "/privateplot/member/basic", query: { flag: "1" } })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleCommitDialog() {
      let that = this;
      if (
        that.elementDeptId != null &&
        that.elementDeptId.length != 0 &&
        that.selectedDepartTp < 5
      ) {
        Message.error({
          message: "所属机构只能选择医院和科室！",
          showClose: true
        });
        return;
      }
      let eimsUser = {
        userId: that.dialog.form.userId,
        name: that.dialog.form.name,
        //这个是为了保存到数据库使用的
        majorDepartId:
          that.elementDeptId[that.elementDeptId.length - 1] ||
          this.dialog.form.majorDepartId,
        //这个是为了回显组件数据使用的
        elementDeptId: that.elementDeptId
      };
      //保存信息
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          userId: that.dialog.form.userId,
          department: that.elementDeptId[that.elementDeptId.length - 1]
        }
      };
      http
        .post(window.config.api.baseUrl + "/eims-api/user/updateDept", obj)
        .then(value => {
          if (value.data.code === "00000") {
            Message.success({ message: "机构信息修改成功", showClose: true });
            //重新触发刷新数据
            this.handleCloseDialog();
            this.queryData();
          } else {
          }
        })
        .finally(() => {})
        .catch(error => {});
    },
    handleCloseDialog() {
      this.$refs["ruleForm"].resetFields();
      Object.assign(this.$data.dialog.form, this.$options.data().dialog.form);
      this.dialog.isShow = false;
    },

    handleCloseDialog2() {
      this.elementDeptId = [];
      this.view.viewDialogFlag = false;
      this.selectedDepartTp = null;
    },

    //拿到弹窗的选择框选择的部门id
    handleDialogDeptChange(value) {
      if (this.$refs.editDeptCascader.getCheckedNodes()[0] !== undefined) {
        // console.log(this.$refs.editDeptCascader.getCheckedNodes()[0].data);
        this.selectedDepartTp = this.$refs.editDeptCascader.getCheckedNodes()[0].data.tp;
      } else {
        this.selectedDepartTp = null;
      }
      if (value != null) {
        this.elementDeptId = value;
        this.dialog.form.majorDepartId = value[value.length - 1];
      }
    },
    handleUpdateDeptClick(row) {
      this.dialog.isShow = true;
      this.dialog.dialogType = DIALOG_TYPE_UPDATE;
      this.dialog.form.name = row.name;
      this.dialog.form.userId = row.userId;
      this.dialog.readOnlyFlg = true;
    }
  }
};
</script>
<style scoped>
.member-form-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.member-head-opt-btn {
  margin: 0 10px;
}
.member-manage-table {
  padding-top: 20px;
}
/deep/ .el-form-item--small.el-form-item {
  margin-bottom: 0;
}
/deep/ .el-form-item--small.el-form-item > * {
  margin-top: 5px;
}
/deep/
  .member-approve-table
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped
  td {
  background-color: #f3fdff !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/MemberManage.vue